import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation RemoveRecordResponsiblePerson(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
    $employeeId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                removeResponsiblePerson(
                  spaceRecordId: $spaceRecordId
                  employeeId: $employeeId
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.RemoveRecordResponsiblePersonMutation,
  undefined,
  graphql.schema.RemoveRecordResponsiblePersonMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
